import { lazy, Suspense, useEffect } from "react";
import type { AppRouteObject } from "../../routes";

const ApprovalSection = lazy(() => import("../components/ApprovalSection")); // Adjust the import path as necessary

export const ApprovalRoute: AppRouteObject = {
    path: "/:realm/approval",
    element: <ApprovalSection />,
    handle: {
        access: "anyone",
    },
};
